// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"7147f489","247":"21e9f5cd","422":"ea1a5f61","627":"6f4f27a8","768":"0f2299c5","834":"5baf4d45","867":"a05e1ff5","923":"d4ec2e3f","938":"dcb732c5"}[chunkId] + ".chunk.js";
};